module.exports = __webpack_public_path__ + "static/media/CONCH-ink.f433fc8a.jpeg";